export default __webpack_public_path__ + "static/media/closet1-480w.2a124b1a.png";